module.exports = __webpack_public_path__ + "img/logo1.1e68a1cc.png";